export enum BrakeSevereLevel {
  // TODO: 서버스펙으로 바뀔수도?
  NORMAL = 'NORMAL',
  CAUTION = 'CAUTION',
  SEVERE = 'SEVERE',
}

export enum BrakeEnergyLevel {
  LEVEL1,
  LEVEL2,
  LEVEL3,
}

export const EnergyLevelThreshold = {
  LEVEL0: 0,
  LEVEL1: 50000,
  LEVEL2: 500000,
  LEVEL3: 1500000,
} as const;

function useBrakePadSeverity({vin}: {vin: string}) {
  /**
   * 가혹 트립수 : severeTripCount
   * 동종 차종 평균 가혹 트립수 :  avgSevereCount
   * https://hmg.dooray.com/project/tasks/3787746169343737976#comment-3842956949378155142
   *
   * 가혹 제동 수 Case
   * 평균 미만 / 평균 / 평균 초과 / no data / etc error
   */

  /**
   * 제동 에너지
   * < 1구간 (0 ~ 50,000J) >
   * < 2구간 (50,001 ~ 500,000J)>
   * < 3구간 (500,001 ~ 1,500,000J)>
   */

  /**
   * FIXME: energyUnit ->> 임시로 넣어둠.
   * 단위값 서버에서 받아오거나 변환 필요하면 나중에 추가
   */
  const energyUnit = 'J';
  return {
    energyUnit,
    getSevereLevel,
    getEnergyLevel,
  };
}

function getSevereLevel(severeTripCount: number, averageSevereTripCount: number) {
  if (severeTripCount < averageSevereTripCount) {
    return BrakeSevereLevel.NORMAL;
  }
  if (severeTripCount === averageSevereTripCount) {
    return BrakeSevereLevel.CAUTION;
  }
  if (severeTripCount > averageSevereTripCount) {
    return BrakeSevereLevel.SEVERE;
  }
  return BrakeSevereLevel.NORMAL;
}

function getEnergyLevel(onOffEnergySum: number) {
  if (EnergyLevelThreshold.LEVEL0 <= onOffEnergySum && onOffEnergySum <= EnergyLevelThreshold.LEVEL1) {
    return BrakeEnergyLevel.LEVEL1;
  }
  if (EnergyLevelThreshold.LEVEL1 < onOffEnergySum && onOffEnergySum <= EnergyLevelThreshold.LEVEL2) {
    return BrakeEnergyLevel.LEVEL2;
  }
  if (EnergyLevelThreshold.LEVEL2 < onOffEnergySum && onOffEnergySum <= EnergyLevelThreshold.LEVEL3) {
    return BrakeEnergyLevel.LEVEL3;
  }
  return BrakeEnergyLevel.LEVEL1;
}

export default useBrakePadSeverity;
